import {Injectable} from '@angular/core';
import {Action, Store} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {ClientsListService} from './clients-list.service';
import * as fromRoot from '../../../../state/app.state';
import {Observable, of} from "rxjs";
import {catchError, map, mergeMap, tap} from "rxjs/operators";
import {FetchDashboardFilterModel} from "../model/fetch-dashboard-filter.model";
import {FetchStatusFilterModel} from "../model/fetch-status-filter.model";
import {FetchClinicFilterModel} from "../model/fetch-clinic-filter.model";
import {FetchGroupsListModel} from "../model/fetch-groups-list.model";
import {
  FetchParticipantsBehaviourListModel
} from "../model/fetch-participants-behaviour-list.model";
import {
  FetchMeasurementFilterModel
} from "../model/fetch-measurement-filter.model";
import {AddMetricOptionModel} from '../model/add-metric-option.model';
import {
  AddMetricOptionFailure,
  AddMetricOptionRequest,
  AddMetricOptionSuccess,
  FetchClientsListFailure,
  FetchClientsListRequest,
  FetchClientsListSuccess,
  FetchClinicFilterFailure,
  FetchClinicFilterRequest,
  FetchClinicFilterSuccess,
  FetchClinicListFailure,
  FetchClinicListRequest,
  FetchClinicListSuccess,
  FetchClinicStatusFilterListFailure,
  FetchClinicStatusFilterListRequest,
  FetchClinicStatusFilterListSuccess,
  FetchDashboardFilterFailure,
  FetchDashboardFilterRequest,
  FetchDashboardFilterSuccess,
  FetchGroupListFilterFailure,
  FetchGroupListFilterRequest,
  FetchGroupListFilterSuccess,
  FetchGroupsListFailure,
  FetchGroupsListRequest,
  FetchGroupsListSuccess,
  FetchGroupTypeFilterFailure,
  FetchGroupTypeFilterRequest,
  FetchGroupTypeFilterSuccess,
  FetchMeasurementFilterFailure,
  FetchMeasurementFilterRequest,
  FetchMeasurementFilterSuccess,
  FetchMetricOptionListFailure,
  FetchMetricOptionListRequest,
  FetchMetricOptionListSuccess,
  FetchOrgTypeFilterListFailure,
  FetchOrgTypeFilterListRequest,
  FetchOrgTypeFilterListSuccess,
  FetchParticipantsAndCaregiversListFailure,
  FetchParticipantsAndCaregiversListRequest,
  FetchParticipantsAndCaregiversListSuccess,
  FetchParticipantsBehaviourListFailure,
  FetchParticipantsBehaviourListRequest,
  FetchParticipantsBehaviourListSuccess,
  FetchParticipantsWeightListFailure,
  FetchParticipantsWeightListRequest,
  FetchParticipantsWeightListSuccess,
  FetchStatusFilterFailure,
  FetchStatusFilterRequest,
  FetchStatusFilterSuccess,
  FetchUserStatusListFilterFailure,
  FetchUserStatusListFilterRequest,
  FetchUserStatusListFilterSuccess,
  UpdateMetricOptionFailure,
  UpdateMetricOptionRequest,
  UpdateMetricOptionSuccess
} from './clients-list.actions';
import {CommonService} from '../../../shared/services/common.service';
import {UpdateMetricOptionModel} from '../model/update-metric-option.model';
import {
  FetchGroupTypeFilterModel
} from "../model/fetch-group-type-filter.model";


@Injectable()
export class ClientsListEffects {
  fetchClientsList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchClientsListRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.clientsListService.fetchClientsList().pipe(
          map((response: any) => {
            const {data, message} = response;
            const clientsList: any[] = data;

            return FetchClientsListSuccess({clientsList, message});
          }),
          catchError(() => {
            return of(FetchClientsListFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchClientsListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchClientsListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  )
  fetchDashboardFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchDashboardFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.clientsListService.fetchDashboardFilter().pipe(
          map((response: FetchDashboardFilterModel['response']) => {
            const {data, message} = response;
            return FetchDashboardFilterSuccess({
              dashboardFilter: data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchDashboardFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchDashboardFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchDashboardFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchClinicFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchClinicFilterRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.clientsListService.fetchClinicFilter(payload).pipe(
          map((response: FetchClinicFilterModel['response']) => {
            const {data, message} = response;
            return FetchClinicFilterSuccess({
              clinicFilter: data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchClinicFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchClinicFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchClinicFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchStatusFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchStatusFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.clientsListService.fetchStatusFilter().pipe(
          map((response: FetchStatusFilterModel['response']) => {
            const {data, message} = response;
            return FetchStatusFilterSuccess({
              statusFilter: data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchStatusFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchStatusFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchStatusFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchGroupTypeFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchGroupTypeFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.clientsListService.fetchGroupTypeFilter().pipe(
          map((response: FetchGroupTypeFilterModel['response']) => {
            const {data, message} = response;
            return FetchGroupTypeFilterSuccess({
              groupTypeFilter: data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchGroupTypeFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchGroupTypeFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchGroupTypeFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchClinicList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchClinicListRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.clientsListService.fetchClinicList(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchClinicListSuccess({
              clinicsList: data,
              message
            });
          }),
          catchError(() => {
            return of(FetchClinicListFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchClinicListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchClinicListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  )
  fetchGroupsList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchGroupsListRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload: FetchGroupsListModel['request']) =>
        this.clientsListService.fetchGroupsList(payload).pipe(
          map((response: FetchGroupsListModel['response']) => {
            const {data, message} = response;
            return FetchGroupsListSuccess({
              groupsList: data,
              message
            });
          }),
          catchError(() => {
            return of(FetchGroupsListFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchGroupsListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchGroupsListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  )
  fetchParticipantsAndCaregiversList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchParticipantsAndCaregiversListRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.clientsListService.fetchParticipantsAndCaregiversList(payload)
          .pipe(
            map((response) => {
              const {data, message} = response;
              return FetchParticipantsAndCaregiversListSuccess({
                participantsAndCaregiversList: data,
                message
              });
            }),
            catchError(() => {
              return of(FetchParticipantsAndCaregiversListFailure());
            }),
            tap((action: any) => {
              if (action.type === FetchParticipantsAndCaregiversListSuccess.type) {
                // Code to execute on API Success Action dispatch
              } else if (action.type === FetchParticipantsAndCaregiversListFailure.type) {
                // Code to execute on API Failure Action dispatch
              }
            })
          )
      )
    )
  )
  fetchParticipantsWeightList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchParticipantsWeightListRequest),
      map((action) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.clientsListService.fetchParticipantsWeightList(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchParticipantsWeightListSuccess({
              participantsWeightList: data,
              message
            });
          }),
          catchError(() => {
            return of(FetchParticipantsWeightListFailure());
          }),
          tap((action) => {
            if (action.type === FetchParticipantsWeightListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchParticipantsWeightListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  )
  fetchParticipantsBehaviourList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchParticipantsBehaviourListRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload: FetchParticipantsBehaviourListModel['request']) =>
        this.clientsListService.fetchParticipantsBehaviourList(payload).pipe(
          map((response: FetchParticipantsBehaviourListModel['response']) => {
            const {data, message} = response;
            return FetchParticipantsBehaviourListSuccess({
              participantsBehaviourList: data,
              message
            });
          }),
          catchError(() => {
            return of(FetchParticipantsBehaviourListFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchParticipantsBehaviourListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchParticipantsBehaviourListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );
  fetchMetricOptionList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchMetricOptionListRequest),
      map((action) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.clientsListService.fetchMetricOptionList(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchMetricOptionListSuccess({
              measurementInformationList: data,
              message
            });
          }),
          catchError(() => {
            return of(FetchMetricOptionListFailure());
          }),
          tap((action) => {
            if (action.type === FetchMetricOptionListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchMetricOptionListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  )
  fetchMeasurementFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchMeasurementFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.clientsListService.fetchMeasurementFilter().pipe(
          map((response: FetchMeasurementFilterModel['response']) => {
            const {data, message} = response;
            return FetchMeasurementFilterSuccess({
              measurementFilter: data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchMeasurementFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchMeasurementFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchMeasurementFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  addMetricOption$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(AddMetricOptionRequest),
      map((action) => {
        this.commonService.startLoading();
        const payload: AddMetricOptionModel['request'] = {
          name: action.payload.name,
          code: action.payload.code,
          type: action.payload.type,
          isActive: action.payload.isActive,
        }
        const extras = action.payload.extras;
        return {
          payload,
          extras,
        };
      }),
      mergeMap(({payload, extras}) =>
        this.clientsListService.addMetricOption(payload).pipe(
          map((response) => {
            const {message} = response;
            return AddMetricOptionSuccess({
              message
            });
          }),
          catchError(() => {
            return of(AddMetricOptionFailure());
          }),
          tap((action) => {
            this.commonService.stopLoading();
            if (action.type === AddMetricOptionSuccess.type) {
              this.commonService.closeDialog();
              this.commonService.notification(action.message, 'success');
              // call fetch metric option list api
              this.store.dispatch(FetchMetricOptionListRequest({
                payload: extras,
              }));
            } else if (action.type === AddMetricOptionFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );
  updateMetricOption$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(UpdateMetricOptionRequest),
      map((action) => {
        this.commonService.startLoading();
        const payload: UpdateMetricOptionModel['request'] = {
          metricId: action.payload.metricId,
          name: action.payload.name,
          code: action.payload.code,
          type: action.payload.type,
          isActive: action.payload.isActive,
        }
        const extras = action.payload.extras;
        return {
          payload,
          extras,
        };
      }),
      mergeMap(({payload, extras}) =>
        this.clientsListService.updateMetricOption(payload).pipe(
          map((response) => {
            const {message} = response;
            return UpdateMetricOptionSuccess({
              message
            });
          }),
          catchError(() => {
            return of(UpdateMetricOptionFailure());
          }),
          tap((action) => {
            this.commonService.stopLoading();
            if (action.type === UpdateMetricOptionSuccess.type) {
              this.commonService.closeDialog();
              this.commonService.notification(action.message, 'success');
              // call fetch metric option list api
              this.store.dispatch(FetchMetricOptionListRequest({
                payload: extras,
              }));
            } else if (action.type === UpdateMetricOptionFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );
  fetchGroupListFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchGroupListFilterRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.clientsListService.fetchGroupListFilter(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchGroupListFilterSuccess({
              data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchGroupListFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchGroupListFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchGroupListFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchUserStatusListFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchUserStatusListFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.clientsListService.fetchUserStatusListFilter().pipe(
          map((response) => {
            const {data, message} = response;
            return FetchUserStatusListFilterSuccess({
              data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchUserStatusListFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchUserStatusListFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchUserStatusListFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchOrgTypeFilterList: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchOrgTypeFilterListRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.clientsListService.fetchOrgTypeFilterList().pipe(
          map((response) => {
            const {data, message} = response;
            return FetchOrgTypeFilterListSuccess({
              data,
              message
            });
          }),
          catchError(() => {
            return of(FetchOrgTypeFilterListFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchOrgTypeFilterListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchOrgTypeFilterListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  )
  fetchClinicStatusFilterList: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchClinicStatusFilterListRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.clientsListService.fetchClinicStatusFilterList().pipe(
          map((response) => {
            const {data, message} = response;
            return FetchClinicStatusFilterListSuccess({
              data,
              message
            });
          }),
          catchError(() => {
            return of(FetchClinicStatusFilterListFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchClinicStatusFilterListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchClinicStatusFilterListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  )

  constructor(
    private store: Store<fromRoot.State>,
    private clientsListService: ClientsListService,
    private actions: Actions,
    private commonService: CommonService,
  ) {
  }
}
